/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleProvisioningControllerSyncStatusQueryResponse, TrimbleProvisioningControllerSyncStatus400, TrimbleProvisioningControllerSyncStatus401, TrimbleProvisioningControllerSyncStatus403, TrimbleProvisioningControllerSyncStatus404 } from "../../models/trimbleProvisioningController/TrimbleProvisioningControllerSyncStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleProvisioningControllerSyncStatus } from "../../clients/trimble-provisioningService/trimbleProvisioningControllerSyncStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleProvisioningControllerSyncStatusQueryKey = () => [{
  url: '/api/v1/trimble-provisioning-sync-status'
}] as const;
export type TrimbleProvisioningControllerSyncStatusQueryKey = ReturnType<typeof trimbleProvisioningControllerSyncStatusQueryKey>;
export function trimbleProvisioningControllerSyncStatusQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleProvisioningControllerSyncStatusQueryKey();
  return queryOptions<TrimbleProvisioningControllerSyncStatusQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerSyncStatus400 | TrimbleProvisioningControllerSyncStatus401 | TrimbleProvisioningControllerSyncStatus403 | TrimbleProvisioningControllerSyncStatus404>, TrimbleProvisioningControllerSyncStatusQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleProvisioningControllerSyncStatus(config);
    }
  });
}

/**
 * @summary Health of the Trimble Event Service poll in this environment
 * {@link /api/v1/trimble-provisioning-sync-status}
 */
export function useTrimbleProvisioningControllerSyncStatus<TData = TrimbleProvisioningControllerSyncStatusQueryResponse, TQueryData = TrimbleProvisioningControllerSyncStatusQueryResponse, TQueryKey extends QueryKey = TrimbleProvisioningControllerSyncStatusQueryKey>(options: {
  query?: Partial<QueryObserverOptions<TrimbleProvisioningControllerSyncStatusQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerSyncStatus400 | TrimbleProvisioningControllerSyncStatus401 | TrimbleProvisioningControllerSyncStatus403 | TrimbleProvisioningControllerSyncStatus404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleProvisioningControllerSyncStatusQueryKey();
  const query = useQuery({
    ...trimbleProvisioningControllerSyncStatusQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleProvisioningControllerSyncStatus400 | TrimbleProvisioningControllerSyncStatus401 | TrimbleProvisioningControllerSyncStatus403 | TrimbleProvisioningControllerSyncStatus404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}